import { List } from '@kerfjs/ui/list';
import { ListHeader } from '@kerfjs/ui/list-header';
import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { ValueTable, ValueTableRow } from '@kerfjs/ui/value-table';
import type { SafeHtml } from 'kerfjs';
import { MessageCircleQuestionMark } from 'lucide';

import type { AnalysisSummaryT } from '../../../../../../shared/contract/analysis.js';

/**
 * The pricing check's stated assumptions (FR-3.12, HS2-B0AK80): clarification
 * questions it benchmarked as written instead of waiting for an answer. While the
 * questions are open, or were skipped (HS2-54N88P), "Answer and Re-check…" opens
 * them; answering re-runs the check with the answers.
 */
export function OverviewOpenQuestionsSection({
  questions,
  answerable,
}: {
  questions: NonNullable<AnalysisSummaryT['openQuestions']>;
  answerable: boolean;
}): SafeHtml {
  if (questions.length === 0) return <></>;
  return (
    <List>
      {answerable ? (
        <ListHeader
          label="Stated Assumptions"
          action="open-questions"
          actionLabel="Answer and Re-check…"
          actionIcon={<LucideIcon icon={MessageCircleQuestionMark} name="" />}
        />
      ) : (
        <ListHeader label="Stated Assumptions" />
      )}
      <ValueTable label="Stated Assumptions">
        {questions.map((question) => (
          <ValueTableRow label={question.label} value="Checked as written" />
        ))}
      </ValueTable>
    </List>
  );
}
